import React from "react";
import { getTitleDecoration } from "utils/common";
import { isAuthenticated } from "utils/common";

const DetailPromotion = ({ promotion }) => {
  let display = isAuthenticated()
    ? {
        title: promotion.title_login,
        description: promotion.description_login,
      }
    : {
        title: promotion.title_nologin,
        description: promotion.description_nologin,
      };

  return (
    <>
      <div className="mx-md-0 my-3">
        {/* DECORATION */}
        <div
          className="d-block d-md-inline-block mb-1 mb-md-0"
          dangerouslySetInnerHTML={{
            __html: getTitleDecoration(
              promotion?.title_decoration?.title_decoration_content
            ),
          }}
        ></div>

        {/* TITLE */}
        <span className="align-middle fw-600 fs-16">{display.title}</span>
      </div>

      <div className="border-news-top"></div>

      {/* DESRIPTION */}
      <div className="border-color-black border-form-hidden border-radius-5 py-3 my-2 mx-md-0 px-0 px-md-3">
        <div
          dangerouslySetInnerHTML={{
            __html: display.description,
          }}
        ></div>
      </div>
    </>
  );
};

export default DetailPromotion;
